import { type PriceData } from "~/domains/pricing/types/PriceData";
import { nonVolatileText, text } from "../../../utils/PriceUtils";
import { resolveUrl } from "../../../utils/url/urlResolver";
import { BottomNavigationItem } from "~/features/BottomNavigation/BottomNavigation";
import { CART_PAGE } from "~/utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectMinicartData } from "~/features/cart/minicart/minicartRedux";
import { userIsCustomer } from "~/domains/user/utils/roles";
import { PersonalNavItem } from "~/features/navigation/components/headerMenu/PersonalNavItem";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

function useMinicartLogic() {
  const { count, total, show, url } = useSelector(selectMinicartData);
  const webservicesDisabled = window.SCHA.config.disableAllWS;
  const totalStr = webservicesDisabled ? "-" : getPriceLabel(total, count);

  return {
    totalStr,
    url: resolveUrl(url),
    isActive: window.location.pathname.endsWith(CART_PAGE),
    show,
    count,
  };
}

export const HeaderMinicart = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { show, totalStr, url, count } = useMinicartLogic();

  if (!show) {
    return null;
  }

  let extraProps;
  if (userIsCustomer()) {
    extraProps = {
      label: totalStr,
    };
  } else {
    extraProps = {
      badgeContent: count,
    };
  }

  return (
    <a href={url} className={className} data-test-id={"minicart"}>
      <PersonalNavItem {...extraProps} icon={<ShoppingCartOutlinedIcon />} name={t("header.link.cart")} />
    </a>
  );
};
export const MobileMinicart = () => {
  const { show, totalStr, count, url, isActive } = useMinicartLogic();
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  let extraProps;
  if (userIsCustomer()) {
    extraProps = {
      name: totalStr,
    };
  } else {
    extraProps = {
      name: t("breadcrumb.cart"),
      quantity: count,
    };
  }

  return (
    <a href={url} data-test-id={"minicart"}>
      <BottomNavigationItem {...extraProps} icon={<ShoppingCartOutlinedIcon />} isActive={isActive} />
    </a>
  );
};

const getPriceLabel = (total: PriceData | undefined, qty: number) => {
  let totalStr;
  if (total === undefined) {
    totalStr = "-";
  } else {
    totalStr = qty > 0 ? text(total, "-") : nonVolatileText(total);
  }
  return totalStr;
};
